export interface CompileResult {
  success: boolean
  pdf?: Blob
  error?: string
  logs?: string[]
}

const LATEX_API_URL = 'https://latex.ytotech.com/builds/sync'

export async function compileLatex(source: string): Promise<CompileResult> {
  try {
    const response = await fetch(LATEX_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        compiler: 'pdflatex',
        resources: [
          {
            main: true,
            content: source,
          },
        ],
      }),
    })

    if (!response.ok) {
      const errorText = await response.text()
      return {
        success: false,
        error: `Compilation failed: ${response.status} ${response.statusText}`,
        logs: [errorText],
      }
    }

    const contentType = response.headers.get('content-type')
    if (contentType?.includes('application/pdf')) {
      const pdf = await response.blob()
      return {
        success: true,
        pdf,
      }
    } else {
      // API returns JSON with error details
      const errorData = (await response.json()) as { error?: string; logs?: string[] }
      return {
        success: false,
        error: errorData.error || 'Compilation failed',
        logs: errorData.logs || [],
      }
    }
  } catch (err) {
    return {
      success: false,
      error: err instanceof Error ? err.message : 'Unknown compilation error',
    }
  }
}
